import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const comparisonStringUiNodeSpec: NodeSpec<NodeCfg<'comparisonString'>> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'output', 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { not: false, operation: '=' }, id: getUID(), kind: 'comparisonString', disabled: false, width: 220 }),
    controls: nodeCfg => ({
        not: defineControlOpts({ cfg: { kind: 'boolean', label: 'Not' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.not }),
        operation: defineControlOpts({
            cfg: {
                items: [
                    { label: '=', value: '=' },
                    { label: 'contains', value: 'contains' },
                    { label: 'startsWith', value: 'startsWith' },
                    { label: 'endsWith', value: 'endsWith' },
                ],
                kind: 'selection',
                label: 'Operation',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.operation,
        }),
    }),
    inputs: nodeCfg => ({
        input1: {
            controlOpts: defineControlOpts({
                cfg: {
                    kind: 'text',
                },
                value: nodeCfg.socketDefaults?.inputs?.input1,
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
            socket: 'string',
            label: 'Input 1',
        },
        input2: {
            controlOpts: defineControlOpts({
                cfg: {
                    kind: 'text',
                },
                value: nodeCfg.socketDefaults?.inputs?.input2,
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
            socket: 'string',
            label: 'Input 2',
        },
    }),
    kindLabel: 'Text Comparison',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
